import React from "react";
import FaqList from "../components/FaqList";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { tubTileFaq, countertopsFaq, seo } from "../data/siteData";

export function TubTileFaq() {
  useSeo(seo["/tub-tile-faq"].title, seo["/tub-tile-faq"].description);
  useReveal();
  return (
    <>
      <section className="border-b-4 border-[#244aa2] bg-[#f7f7f7] py-12">
        <div className="mr-container">
          <h1 className="mr-h1 text-3xl sm:text-4xl">{tubTileFaq.h1}</h1>
          <p className="mt-3 text-[#575757]">
            Frequently asked questions about bathtub and wall tile reglazing in Connecticut.
          </p>
        </div>
      </section>
      <section className="bg-white py-14">
        <div className="mr-container">
          <FaqList items={tubTileFaq.items} />
        </div>
      </section>
      <CtaBand headline="Still have a question about reglazing?" />
    </>
  );
}

export function CountertopsFaq() {
  useSeo(seo["/countertops-faq"].title, seo["/countertops-faq"].description);
  useReveal();
  return (
    <>
      <section className="border-b-4 border-[#244aa2] bg-[#f7f7f7] py-12">
        <div className="mr-container">
          <h1 className="mr-h1 text-3xl sm:text-4xl">{countertopsFaq.h1}</h1>
          <p className="mt-3 text-[#575757]">
            Frequently asked questions about kitchen countertop resurfacing.
          </p>
        </div>
      </section>
      <section className="bg-white py-14">
        <div className="mr-container">
          <FaqList items={countertopsFaq.items} />
        </div>
      </section>
      <CtaBand headline="Ready to resurface your countertops?" />
    </>
  );
}
